import { SessionStoreKey } from '../storage/session-store-key.enum';
import { SessionStore } from '../storage/storage.interface';

/**
 * ETicket helper utility class
 */
export class ETicketUtil {

    /**
     * Validates existence of ETicket data in current session storage
     */
    public static isEticketListInSession(session: SessionStore | void): boolean {
        if (session === undefined) {
            return false;
        }

        const existingSession = session as SessionStore;

        return existingSession[SessionStoreKey.EticketList] !== null;
    }

    /**
     * Validates expiry of ETicket data in current session storage
     */
    public static isEticketListValidForSession(session: SessionStore): boolean {
        const existingSession = session as SessionStore;

        if (existingSession[SessionStoreKey.EticketListTTL] !== undefined) {
            const ttl = existingSession[SessionStoreKey.EticketListTTL] as number;
            return ttl >= Date.now();
        }

        return true;
    }

}
